/**
 * @file back-to-top
 */
(function ($, Drupal, once) {
  "use strict";

  Drupal.behaviors.kodakBackToTop = {
    attach: function (context, settings) {
      if ($(".cta.back-to-top").length > 0) {
        // Back to top JS
        const $backToTop = $(".cta.back-to-top");
        $(once("backToTop", $backToTop, context)).click(function (e) {
          e.preventDefault();
          $("html, body").animate({ scrollTop: 0 }, 50);
          return false;
        });
      }
    },
  };
})(jQuery, Drupal, once);
